module.exports = __webpack_public_path__ + "media/images/products/longlife/longlife-flow-arrow-01e66d0156dcc16abf3c286ff6ade4ad.svg";